import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import { JSON_CONTENT_TYPE, CONTENT_TYPE } from "../common";
export var jsonOptions = {
  headers: _defineProperty({}, CONTENT_TYPE, "".concat(JSON_CONTENT_TYPE, "; charset=UTF-8"))
};